import * as $ from 'jquery';
import {StickyHeader} from './Core/StickyHeader';
import {Breadcrumb} from './Core/Breadcrumb';
import {Menu} from './Core/Menu';
import 'es6-promise/dist/es6-promise.auto.js';
import {TriggerLink} from './Core/TriggerLink';
import {HeaderMenu} from './Core/HeaderMenu';
import {ShibFeLoginController} from './Core/ShibFeLoginController';
import {Miscellaneous} from './Core/Miscellaneous';
import {SolrSuggestController} from './SolrSuggest/SolrSuggestController';

$(() => {
  const menu = new Menu();
  new StickyHeader(menu);
  new Breadcrumb();
  new TriggerLink();
  new HeaderMenu();
  new ShibFeLoginController();
  new Miscellaneous();
  new SolrSuggestController();
});

// module "Accordion" is only loaded if necessary
if ($('.ui-accordion').length) {
  import(/* webpackChunkName: "Accordion" */ './Accordion/Accordion').catch((error) => {
    console.error(error);
  });
}

// module slider is only loaded if necessary
if ($('.js-slider').length || $('.frame--type-gallery').length) {
  import(/* webpackChunkName: "slider" */ './Slider/Index').catch((error) => {
    console.error(error);
  });
}

// module gallery is only loaded if necessary
if ($('.frame--type-gallery').length) {
  import(/* webpackChunkName: "gallery" */ './Gallery/Index').catch((error) => {
    console.error(error);
  });
}

// module datepicker is only loaded if necessary
if ($('.datepicker').length) {
  import(/* webpackChunkName: "datepicker" */ './DatePicker/Index').catch((error) => {
    console.error(error);
  });
}

if ($('.tx-cachet-status').length) {
  import(/* webpackChunkName: "Cachet" */ './Cachet/Index').catch((error) => {
    console.error(error);
  });
}
